import { LevelValue, RankColor, RankGem } from "../constants/user";
import { ILevel } from "../types/user";
import UnrankedIcon from "../assets/rankGem/Unranked/Unranked_1x.webp";
import UnrankedIcon2x from "../assets/rankGem/Unranked/Unranked_2x.webp";
import UnrankedIcon3x from "../assets/rankGem/Unranked/Unranked_3x.webp";
import BeginnerIcon from "../assets/rankGem/Beginner/Beginner_1x.webp";
import BeginnerIcon2x from "../assets/rankGem/Beginner/Beginner_2x.webp";
import BeginnerIcon3x from "../assets/rankGem/Beginner/Beginner_3x.webp";
import IntermediateIcon from "../assets/rankGem/Intermediate/Intermediate_1x.webp";
import IntermediateIcon2x from "../assets/rankGem/Intermediate/Intermediate_2x.webp";
import IntermediateIcon3x from "../assets/rankGem/Intermediate/Intermediate_3x.webp";
import AdvancedIcon from "../assets/rankGem/Advanced/Advanced_1x.webp";
import AdvancedIcon2x from "../assets/rankGem/Advanced/Advanced_2x.webp";
import AdvancedIcon3x from "../assets/rankGem/Advanced/Advanced_3x.webp";
import ExpertIcon from "../assets/rankGem/Expert/Expert_1x.webp";
import ExpertIcon2x from "../assets/rankGem/Expert/Expert_2x.webp";
import ExpertIcon3x from "../assets/rankGem/Expert/Expert_3x.webp";
import MasterIcon from "../assets/rankGem/Master/Master_1x.webp";
import MasterIcon2x from "../assets/rankGem/Master/Master_2x.webp";
import MasterIcon3x from "../assets/rankGem/Master/Master_3x.webp";
import ChampionIcon from "../assets/rankGem/Champion/Champion_1x.webp";
import ChampionIcon2x from "../assets/rankGem/Champion/Champion_2x.webp";
import ChampionIcon3x from "../assets/rankGem/Champion/Champion_3x.webp";
import GrandChampionIcon from "../assets/rankGem/GrandChampion/GrandChampion_1x.webp";
import GrandChampionIcon2x from "../assets/rankGem/GrandChampion/GrandChampion_2x.webp";
import GrandChampionIcon3x from "../assets/rankGem/GrandChampion/GrandChampion_3x.webp";

import { PushNotification } from "./pushNotification";
import {
  User as GraphQLUser,
  LoginReward,
  LoginRewardStatus,
} from "@onmo/graphql/graphql";
import { CoinType, CoinWallet } from "@onmo/graphql/graphql";
import find from "lodash-es/find";
import { BadgeType } from "../components/core/Badge/Badge";
import { getWalletBalance } from "../constants/wallet";

export type TierLevel = {
  __typename: "TierLevel";
  amount: number;
  levelId: string;
};

export const LEVEL_STAGE: ILevel[] = [
  {
    id: "unranked",
    name: RankGem.UnRanked,
    color: RankColor.UnRanked,
    rankColor: "",
    icon: {
      src1x: UnrankedIcon,
      src2x: UnrankedIcon2x,
      src3x: UnrankedIcon3x,
    },
    xp: LevelValue.UnRanked,
  },
  {
    id: "beginner",
    name: RankGem.Beginner,
    rankColor: "#924F00",
    color: RankColor.Beginner,
    icon: {
      src1x: BeginnerIcon,
      src2x: BeginnerIcon2x,
      src3x: BeginnerIcon3x,
    },
    xp: LevelValue.Beginner,
  },
  {
    id: "intermediate",
    name: RankGem.Intermediate,
    color: RankColor.Intermediate,
    rankColor: "#9caac3",
    icon: {
      src1x: IntermediateIcon,
      src2x: IntermediateIcon2x,
      src3x: IntermediateIcon3x,
    },
    xp: LevelValue.Intermediate,
  },
  {
    id: "advanced",
    name: RankGem.Advanced,
    color: RankColor.Advanced,
    rankColor: "#ffd648",
    icon: {
      src1x: AdvancedIcon,
      src2x: AdvancedIcon2x,
      src3x: AdvancedIcon3x,
    },
    xp: LevelValue.Advanced,
  },
  {
    id: "expert",
    name: RankGem.Expert,
    color: RankColor.Expert,
    rankColor: "#ED0000",
    icon: {
      src1x: ExpertIcon,
      src2x: ExpertIcon2x,
      src3x: ExpertIcon3x,
    },
    xp: LevelValue.Expert,
  },
  {
    id: "master",
    name: RankGem.Master,
    color: RankColor.Master,
    rankColor: "#23AEFD",
    icon: {
      src1x: MasterIcon,
      src2x: MasterIcon2x,
      src3x: MasterIcon3x,
    },
    xp: LevelValue.Master,
  },
  {
    id: "champion",
    name: RankGem.Champion,
    color: RankColor.Champion,
    rankColor: "#9047F5",
    icon: {
      src1x: ChampionIcon,
      src2x: ChampionIcon2x,
      src3x: ChampionIcon3x,
    },
    xp: LevelValue.Champion,
  },
  {
    id: "grand-champion",
    name: RankGem.GrandChampion,
    color: RankColor.GrandChampion,
    rankColor: "",
    icon: {
      src1x: GrandChampionIcon,
      src2x: GrandChampionIcon2x,
      src3x: GrandChampionIcon3x,
    },
    xp: LevelValue.GrandChampion,
  },
];

const getIconFromType = (type: BadgeType) => {
  switch (type) {
    case "grand-champion":
      return `${GrandChampionIcon} 1x, ${GrandChampionIcon2x} 2x, ${GrandChampionIcon3x} 3x`;
    case "champion":
      return `${ChampionIcon} 1x, ${ChampionIcon2x} 2x, ${ChampionIcon3x} 3x`;
    case "master":
      return `${MasterIcon} 1x, ${MasterIcon2x} 2x, ${MasterIcon3x} 3x`;
    case "expert":
      return `${ExpertIcon} 1x, ${ExpertIcon2x} 2x, ${ExpertIcon3x} 3x`;
    case "advanced":
      return `${AdvancedIcon} 1x, ${AdvancedIcon2x} 2x, ${AdvancedIcon3x} 3x`;
    case "intermediate":
      return `${IntermediateIcon} 1x, ${IntermediateIcon2x} 2x, ${IntermediateIcon3x} 3x`;
    case "beginner":
      return `${BeginnerIcon} 1x, ${BeginnerIcon2x} 2x, ${BeginnerIcon3x} 3x`;
    default:
      return `${UnrankedIcon} 1x, ${UnrankedIcon2x} 2x, ${UnrankedIcon3x} 3x`;
  }
};

const formatLevelStage = (tierLevels?: TierLevel[]) => {
  if (!tierLevels) return LEVEL_STAGE;

  const getLevelXp = (id: string) => {
    const currentLevel = tierLevels?.find((tier) => {
      return tier.levelId === id;
    });
    return currentLevel?.amount || 0;
  };

  const levelFormatted = LEVEL_STAGE.map((level) => {
    return { ...level, xp: getLevelXp(level.id) };
  });

  return levelFormatted;
};

const getCurrentRank = (props: {
  xp?: number;
  wallet?: CoinWallet[];
  tierLevels?: TierLevel[];
  baseCoinType?: CoinType;
}) => {
  const gzTokens = getWalletBalance(
    props.wallet || [],
    props.baseCoinType || CoinType.GzTokens,
  );

  const currentXp = gzTokens || props.xp || 0;
  const levelStage = formatLevelStage(props.tierLevels);
  if (!props.tierLevels) return undefined;

  if (!currentXp || currentXp < 1)
    return {
      ...levelStage[0],
      levelPercent: 0,
      currentLevelXp: 0,
      preLevel: levelStage[0],
      nextLevel: levelStage[1],
    };

  const currentLevelIndex =
    levelStage?.filter((level) => {
      return level.xp <= currentXp;
    }).length - 1;

  const preLevel = levelStage?.[currentLevelIndex - 1];
  const currentLevel = levelStage[currentLevelIndex];
  const nextLevel = levelStage[currentLevelIndex + 1];
  const levelPercent = !nextLevel
    ? 100
    : ((currentXp - currentLevel.xp) / (nextLevel.xp - currentLevel.xp)) * 100;

  return {
    ...currentLevel,
    xp: currentXp,
    currentLevelXp: currentLevel.xp,
    preLevel: preLevel,
    levelPercent: levelPercent,
    nextLevel: nextLevel,
  };
};

export const isEnableNotification = (user?: GraphQLUser | null) => {
  return !!user?.pushSubscription && user?.pushSubscription !== "null";
};

export const togglePushSubscription = async (user?: GraphQLUser | null) => {
  if (isEnableNotification(user)) {
    return PushNotification.unsubscribe();
  } else {
    return PushNotification.subscribe();
  }
};
const getCurrentDailyReward = (loginRewards: LoginReward[]) => {
  const availableReward = loginRewards?.filter(
    (reward) => reward.claimStatus !== LoginRewardStatus.Unavailable,
  );

  return (availableReward?.length || 0) - 1;
};

const getSpendableGzTokens = (
  coinWallets: CoinWallet[],
  spendableCoinType?: CoinType,
) => {
  if (!coinWallets) return;
  const type = spendableCoinType || CoinType.SpendableGzTokens;
  const spendableGzTokens = find(
    coinWallets,
    (w) => w.itemType === type,
  )?.balance;
  return spendableGzTokens || 0;
};

export const User = {
  formatLevelStage,
  getCurrentRank,
  isEnableNotification,
  togglePushSubscription,
  getCurrentDailyReward,
  getSpendableGzTokens,
  getIconFromType,
};
